import React from 'react';
import Icon from '../Icon/Icon';
import Pill, { PILL } from '../Pill/Pill';
import './MatchAllPill.css';

export default function MatchAllPill({ children }) {
    return <Pill
        className={'MatchAllPill'}
        type={PILL.GRAY}
        iconLeft={<Icon type="logo" className={'MatchAllPill__Icon'}/>}
    >
        {children ?? 'All Existing And New'}
    </Pill>;
}
